export default {
  SET_TEMPLATE(state, template) {
    state.template = template || null
  },
  SET_JOURNEY(state, journey) {
    if (!journey || !journey.clientId) return
    // Reatribuição em vez de mutação de chave: Vue 2 não torna reativa
    // propriedade nova de objeto.
    state.byClientId = { ...state.byClientId, [journey.clientId]: journey }
  },
  SET_OVERVIEW(state, overview) {
    if (!overview || !overview.clientId) return
    state.overviewByClientId = {
      ...state.overviewByClientId,
      [overview.clientId]: overview,
    }
  },
  SET_INDICATORS(state, indicators) {
    state.indicators = indicators || null
  },
  SET_SUMMARIES(state, summaries) {
    const list = Array.isArray(summaries) ? summaries : []
    state.summaries = list.reduce(
      (acc, s) => {
        if (s && s.clientId) acc[s.clientId] = s
        return acc
      },
      { ...state.summaries }
    )
  },
  SET_LOADING(state, loading) {
    state.loading = !!loading
  },
  SET_LOADING_SUMMARIES(state, loading) {
    state.loadingSummaries = !!loading
  },
  SET_ERROR(state, error) {
    state.error = error || null
  },
}
